module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticStyle: {
      "height": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "账号"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "alert",
    class: _vm.flag ? 'dis' : ''
  }, [_c('img', {
    attrs: {
      "src": require("../../static/legend/Alert.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("检测到您已离开该医院所在城市，为了医院数据安全，请确保您的设备处于所登录医院的所在地。")])]), _vm._v(" "), _c('el-button', {
    staticClass: "login-btn",
    on: {
      "click": _vm.onBtnLogin
    }
  }, [_vm._v("登录 ")])], 1)]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(" 联系我们 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("| 隐私政策 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("| 服务协议 | ")]), _vm._v("\n\n      ©2021 上海移宇科技有限公司 版权所有"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("\n        沪ICP备08013753号-3\n      ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v("\n        沪公网安备 31011502014155号\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrap"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/report/logo_zyw.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("医院版")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("移宇在线报表系统")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/report/icon_user.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/report/icon_password.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remember_pwd_row"
  }, [_c('div', {
    staticClass: "fl c1"
  }, [_c('input', {
    attrs: {
      "id": "remember_pwd_check",
      "type": "checkbox"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl c2"
  }, [_c('span', [_vm._v("记住密码")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out_link"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://report.medtrum.cn"
    }
  }, [_vm._v("切换到门诊版")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-195dabe8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginReport.vue
// module id = 738
// module chunks = 1